export default __webpack_public_path__ + "static/media/logoPlaceholder.e19990ee.svg";